const validQpKeys = ['product', 'draw', 'activatedDrawId', 'coupon'] as const;

/**
 * Utility function to construct a return URL with query parameters.
 *
 * @returns URL object with the appended query parameters
 */
export function getReturnUrl(): URL {
  const url = new URL(window.location.pathname, window.location.origin);
  const entries = new URLSearchParams(window.location.search).entries();

  for (const [key, value] of entries) {
    if (validQpKeys.includes(key as (typeof validQpKeys)[number])) {
      if (url.searchParams.has(key)) {
        // Only apply latest key if duplicate keys exist in the search params
        url.searchParams.delete(key);
      }
      url.searchParams.append(key, value);
    }
  }

  return url;
}
